import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { EasyClaimDocumentType } from 'src/easyclaim.api.client.typescript/src';
import FormattedHtmlMessage from 'src/easyclaim.app.components/common/FormattedHtmlMessage';
import { OverallDashboardPlaceholder } from 'src/easyclaim.app.components/common/ImageRepository';
import { reportError } from 'src/easyclaim.app.libs/reportError';

import {
	ExampleModalImage,
	SelectImage,
	StyledInfoIcon,
} from '../../easyclaim.app.components/index';
import { Image } from '../../easyclaim.app.services/ImageSelectionService';
import { FourAdditionalPicturesProps, isAnyOfImagesLoading } from '../FourAdditionalPictures';

export function OverallDashboardControl(currentAppState: FourAdditionalPicturesProps) {
	return (
		<>
			<h3 className="four-additional-pictures-overall-dashboard-title">
				<FormattedMessage id="fourAdditionalPictures.overallDashboard.title" />
			</h3>
			<p className="four-additional-pictures-overall-dashboard-description">
				<FormattedHtmlMessage id="fourAdditionalPictures.overallDashboard.description" />
				<StyledInfoIcon
					onClick={() => {
						showOverallDashboardExampleImage(currentAppState).catch(reportError);
					}}
				/>
			</p>
			<div className="four-additional-pictures-detail-container">
				<SelectImage
					componentId="overallDashboardImage"
					fileType={EasyClaimDocumentType.OverallDashboardPicture}
					caseId={currentAppState.easyClaimCase?.caseId}
					easyClaimService={currentAppState.easyClaimService}
					currentImage={currentAppState.overallDashboardImage}
					title="overallDashboardImage.headline"
					marginBottom="1rem"
					onChange={(image) => {
						const newState = overallDashboardImageChanged(currentAppState, image);

						void currentAppState.setAppState(newState);
					}}
					onShowExample={() => {
						showOverallDashboardExampleImage(currentAppState).catch(reportError);
					}}
					showUserFeedbackInfo={true}
					placeholder={<OverallDashboardPlaceholder />}
					configuration={currentAppState.easyClaimCase!._configuration!}
					inputError={currentAppState.inputError}
				/>
			</div>
		</>
	);
}

function overallDashboardImageChanged(
	currentAppState: AppState,
	image: Image | undefined
): AppState {
	// const isImageLoading = ImageSelectionService.isImageLoading(image);
	let images: Image[] = [];

	images = image ? images.concat([image]) : images;
	images = currentAppState.dashboardImage
		? images.concat([currentAppState.dashboardImage])
		: images;
	images = currentAppState.windshieldImage
		? images.concat([currentAppState.windshieldImage])
		: images;
	images = currentAppState.vinImage ? images.concat([currentAppState.vinImage]) : images;

	const isImageLoading = isAnyOfImagesLoading(images);

	const newState = Object.assign({}, currentAppState, {
		overallDashboardImage: image,
		isImageLoading: isImageLoading,
	});

	return newState;
}

function showOverallDashboardExampleImage(currentAppState: AppState) {
	const images: ExampleModalImage[] = [
		{ src: `${process.env.PUBLIC_URL}/images/example-overall-dashboard.jpg` },
	];

	return currentAppState.showExampleModal(
		images,
		'fourAdditionalPictures.overallDashboard.exampleModalTitle',
		'fourAdditionalPicturesExampleModal.button.close',
		'overall-dashboard'
	);
}
